"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTransferListConfigs = exports.getInitTableTitleStatus = void 0;
const getInitTableTitleStatus = (titlesTextAndCodeMap, functionalButtonColumnStatus = 'showFunctionalColumn') => {
    let initTableTitleStatus = [];
    if (functionalButtonColumnStatus === 'showFunctionalColumn')
        initTableTitleStatus = new Array({
            isCheckbox: true,
            function: 'del',
            titleText: '',
            titleCode: 'functionalButtons',
            isDisplay: true
        });
    titlesTextAndCodeMap.map((item) => {
        const { titleText, titleCode } = item;
        initTableTitleStatus.push({
            isCheckbox: false,
            function: '',
            titleText,
            titleCode,
            isDisplay: true
        });
    });
    return initTableTitleStatus;
};
exports.getInitTableTitleStatus = getInitTableTitleStatus;
const getTransferListConfigs = (titlesTextAndCodeMap) => {
    const transferListConfigs = [];
    titlesTextAndCodeMap.map((item) => {
        const { titleText, titleCode } = item;
        if (titleCode !== 'rowNumber')
            transferListConfigs.push({
                id: titleCode,
                name: titleText,
                isSelected: false,
                isChecked: false
            });
    });
    return transferListConfigs;
};
exports.getTransferListConfigs = getTransferListConfigs;
